const MAX_TAP_DURATION = 220;
const MAX_TAP_INTERVAL = 190;

// ondblclick doesn't work with stylus so we need to detect double tap manually
export function detectStylusDoubleTap(
  el: Document,
  onDoubleTap: (target: EventTarget | null) => void,
) {
  let isTracking = false;
  let lastTouchEndTime = 0;
  let touchStartTime = 0;

  function now() {
    return performance.now();
  }

  function reset() {
    isTracking = false;
    lastTouchEndTime = 0;
    touchStartTime = 0;
  }

  function handlePointerDown(event: PointerEvent) {
    if (event.pointerType !== 'pen') {
      reset();
      return;
    }

    touchStartTime = now();
  }

  function handlePointerUp(event: PointerEvent) {
    if (event.pointerType !== 'pen') {
      reset();
      return;
    }

    const currentTime = now();
    const tapDuration = currentTime - touchStartTime;

    // Ignore and reset if the tap was too long, likely a press
    if (tapDuration > MAX_TAP_DURATION) {
      reset();
      return;
    }

    const tapInterval = currentTime - lastTouchEndTime;

    // Reset if the previous tap we tracked was too long ago
    if (tapInterval > MAX_TAP_INTERVAL) {
      reset();
    }

    if (isTracking) {
      if (tapInterval < MAX_TAP_INTERVAL) {
        onDoubleTap(event.target);
      }
      reset();
    } else {
      isTracking = true;
      lastTouchEndTime = currentTime;
    }
  }

  el.addEventListener('pointerdown', handlePointerDown, { passive: false });
  el.addEventListener('pointerup', handlePointerUp, { passive: false });
  el.addEventListener('pointercancel', reset, { passive: false });

  return () => {
    el.removeEventListener('pointerdown', handlePointerDown);
    el.removeEventListener('pointerup', handlePointerUp);
    el.removeEventListener('pointercancel', reset);
  };
}
